import React from 'react';
import { inject, observer } from 'mobx-react';
import { RootStore, NewBookingsStore } from 'AppClient/stores';

import styles from './styles.module.scss';

interface Props {
	newBookingsStore?: NewBookingsStore;
}

@inject(({ newBookingsStore }: RootStore) => ({
	newBookingsStore,
}))
@observer
export class StaticMap extends React.Component<Props> {
	componentDidMount() {
		this.props.newBookingsStore!.receiveStaticMap();
	}
	render() {
		const { staticMapSrc } = this.props.newBookingsStore!;

		if (!staticMapSrc) {
			return null;
		}

		return (
			<div className={styles.staticMap}>
				<img alt="route map" width="598px" height="198px" src={staticMapSrc} />
			</div>
		);
	}
}
